var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"share-folder-button",attrs:{"fab":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('share')}}},'v-btn',_vm.sizeProps,false),[_c('v-icon',{attrs:{"color":_vm.isShared ? 'primary' : 'grey'}},[_vm._v("share")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }